// App fan mode — which side of Request this DEVICE uses (locked r6 §4).
//
// Picked on the app's first screen (WelcomeTourPage: "🎧 I perform" /
// "🎉 I'm a fan") and remembered per device: returning fans boot straight
// into fan mode, a signed-out DJ phone gets the same first screen again.
// The role never gates anything server-side — it only decides which
// first-run surface this phone shows. A DJ login always wins over a
// remembered "fan" (Home checks auth first).

export type AppRole = "dj" | "fan";

// The role screen ("I perform / I'm a fan") was parked for build 38 (fans
// web-only) and un-parked for build 41 (founder): a fan pick lands on the
// claim screen — sign in for the leaderboard, or skip; requesting never needs
// an account. Flip to true to park it again (the first screen then shows the
// talent card only); nothing else changes.
export const FAN_MODE_PARKED = false;

// Also read by the boot-spinner tagline script in public/index.html — the
// DJ pitch line must not flash on a fan-role device booting at "/".
const KEY = "rq_app_role";

export const getAppRole = (): AppRole | null => {
  try {
    const v = localStorage.getItem(KEY);
    return v === "dj" || v === "fan" ? v : null;
  } catch {
    return null;
  }
};

export const setAppRole = (role: AppRole) => {
  try {
    localStorage.setItem(KEY, role);
  } catch {}
};

export const clearAppRole = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {}
};
